import {
  CheckCircleIcon,
  ClipboardCheckFilledIcon,
  DiscountFilledIcon,
  DiscountCodeIcon,
  ImagesIcon,
  PackageFilledIcon,
  OrderIcon,
  ShieldCheckMarkIcon,
  ProfileIcon,
  TipJarIcon,
  WalletFilledIcon,
  PaymentFilledIcon,
  NotificationFilledIcon,
} from "@shopify/polaris-icons";

const settingConfig = (cms) => {
  const config = {
    "/": [
      {
        caption: cms("common.actions.dashboard.caption.profile"),
        label: cms("common.actions.dashboard.label.profile"),
        link: "/profile",
        icon: ProfileIcon,
      },
      {
        caption: cms("common.actions.dashboard.caption.commission"),
        label: cms("common.actions.dashboard.label.commission"),
        link: "/commission",
        icon: TipJarIcon,
      },
      {
        caption: cms("common.actions.dashboard.caption.terms"),
        label: cms("common.actions.dashboard.label.terms"),
        link: "/terms",
        icon: ShieldCheckMarkIcon,
      },
    ],
    "/orders": [
      {
        caption: cms("common.actions.orders.caption.acceptance"),
        label: cms("common.actions.orders.label.acceptance"),
        link: "/setting/order",
        icon: OrderIcon,
      },
    ],
    "/payments": [
      {
        caption: cms("common.actions.payments.caption.payouts"),
        label: cms("common.actions.payments.label.payouts"),
        link: "/payouts",
        icon: WalletFilledIcon,
      },
      {
        caption: cms("common.actions.payments.caption.stripe"),
        label: cms("common.actions.payments.label.stripe"),
        link: "/setting/payment",
        icon: PaymentFilledIcon,
      },
      {
        caption: cms("common.actions.payments.caption.paypal"),
        label: cms("common.actions.payments.label.paypal"),
        link: "/setting/payment",
        icon: PaymentFilledIcon,
      },
    ],
    "/products": [
      {
        caption: cms("common.actions.products.caption.approval"),
        label: cms("common.actions.products.label.approval"),
        link: "/setting/product",
        icon: CheckCircleIcon,
      },
      {
        caption: cms("common.actions.products.caption.discount"),
        label: cms("common.actions.products.label.discount"),
        link: "/setting/discount",
        icon: DiscountFilledIcon,
      },
      {
        caption: cms("common.actions.products.caption.productFormLabel"),
        label: cms("common.actions.products.label.productFormLabel"),
        link: "/setting/product/label",
        icon: ClipboardCheckFilledIcon,
      },
      {
        caption: cms("common.actions.products.caption.markup"),
        label: cms("common.actions.products.label.markup"),
        link: "/setting/markup",
        icon: DiscountCodeIcon,
      },
      {
        caption: cms("common.actions.products.caption.shipping"),
        label: cms("common.actions.products.label.shipping"),
        link: "/shipping",
        icon: PackageFilledIcon,
      },
    ],
    "/providers": [
      {
        caption: cms("common.actions.vendors.caption.manageVendor"),
        label: cms("common.actions.vendors.label.manageVendor"),
        link: "/provider/manage",
        icon: ProfileIcon,
      },
      {
        caption: cms("common.actions.vendors.caption.brandPage"),
        id: "brandPage",
        label: cms("common.actions.vendors.label.brandPage"),
        icon: ImagesIcon,
        action: function action() {
          const { token, domain } = this;
          const url = `${domain}/builder/${token}`;
          window.open(url);
        },
      },
      {
        caption: cms("common.actions.vendors.caption.muteNotification"),
        label: cms("common.actions.vendors.label.muteNotification"),
        link: "/setting/notification",
        icon: NotificationFilledIcon,
      },
    ],
  };

  const title = {
    "/": cms("common.actions.title.setting"),
    "/orders": cms("common.actions.title.orderSettings"),
    "/payments": cms("common.actions.title.paymentSettings"),
    "/products": cms("common.actions.title.productSettings"),
    "/providers": cms("common.actions.title.vendorSettings"),
  };

  return { config, title };
};

export default settingConfig;
